import React from "react";
import { Dropdown, MenuProps, Space } from "antd";
import { CheckOutlined, GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { changeLanguage, SupportedLanguage } from "../../i18n";
import "./language-switcher.scss";

interface LanguageSwitcherProps {
  contrastingTextColor?: string;
  style?: React.CSSProperties;
  className?: string;
}

const languages: { key: SupportedLanguage; label: string; flag: string; short: string }[] = [
  { key: "vi", label: "Tiếng Việt", flag: "🇻🇳", short: "VI" },
  { key: "en", label: "English", flag: "🇬🇧", short: "EN" },
];

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  contrastingTextColor,
  style,
  className = "",
}) => {
  const { t, i18n } = useTranslation();
  const currentLang = (i18n.language?.startsWith("en") ? "en" : "vi") as SupportedLanguage;
  const currentItem = languages.find((l) => l.key === currentLang) || languages[0];

  const menuItems: MenuProps["items"] = languages.map((lang) => ({
    key: lang.key,
    label: (
      <Space className="lang-menu-item" style={{ minWidth: 120, justifyContent: "space-between", display: "flex", width: "100%" }}>
        <Space>
          <span style={{ fontSize: "16px" }}>{lang.flag}</span>
          <span style={{ fontWeight: currentLang === lang.key ? 600 : 400 }}>{lang.label}</span>
        </Space>
        {currentLang === lang.key && (
          <CheckOutlined style={{ color: "#1890ff", marginLeft: 8 }} />
        )}
      </Space>
    ),
    onClick: () => changeLanguage(lang.key),
  }));

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <div
        className={`lang-switcher-trigger ${className}`}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 8px",
          borderRadius: 6,
          userSelect: "none",
          color: contrastingTextColor || "inherit",
          ...style,
        }}
        title={t("Đổi ngôn ngữ / Change Language", "Đổi ngôn ngữ / Change Language")}
      >
        <span style={{ fontSize: 16 }}>{currentItem.flag}</span>
        <span style={{ fontSize: 13, fontWeight: 600, letterSpacing: "0.5px" }}>
          {currentItem.short}
        </span>
      </div>
    </Dropdown>
  );
};

export default LanguageSwitcher;
